import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import './styles/main.css';
import './App.css';
import OurVision from './components/OurVision';
import CompanyOverview from './components/CompanyOverview';
import EthicsAndValues from './components/EthicsAndValues';
import OurTeam from './components/OurTeam';
import Products from './components/Product';
import VoyagePage from './components/Voyage';
import ContactPage from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import LifeAtDrBhuPat from './components/LifeAtDrBhuPat';
import MainCareer from './components/MainCareer';
import ProductDetail from './components/ProductDetail';

function App() {
  return (
    <Router>
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ourvision" element={<OurVision />}/>
            <Route path='/companyoverview' element={<CompanyOverview />}/>
            <Route path='/ethicsvalues' element={<EthicsAndValues />}/>
            <Route path='/ourteam' element={<OurTeam />}/>
            <Route path='/products' element={<Products />}/>
            <Route path='/voyage' element={<VoyagePage />}/>
            <Route path='/contact' element={<ContactPage />}/>
            <Route path='/privacy-policy' element={<PrivacyPolicy />}/>
            <Route path='/life-at' element={<LifeAtDrBhuPat />}/>
            <Route path='/career' element={<MainCareer />}/>
            <Route path="/products/:id" element={<ProductDetail />} />
          </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;